import { LinearProgress } from "@material-ui/core";
import ConfigForm, {
  ConfigInput,
  FormOption,
} from "components/Layout/ConfigForm";
import { ShiftConfig } from "generated/graphql";
import React, { useEffect, useState } from "react";

interface PlaybackControlProps {
  shiftConfigs:
    | Pick<
        ShiftConfig,
        "number" | "buildingId" | "Id" | "endTime" | "startTime" | "title"
      >[]
    | undefined;
  handleShiftChange: (shiftNumber: number) => void;
  handleDateChange: (shiftDate: string) => void;
}

interface PlaybackControlState {
  shiftNumber: number;
  shiftDate?: string;
  shiftOption?: FormOption;
  loading: boolean;
}

const DEFAULT_STATE: PlaybackControlState = {
  shiftNumber: 0,
  loading: true,
};
export default function PlaybackControl({
  shiftConfigs,
  handleShiftChange,
  handleDateChange,
}: PlaybackControlProps) {
  const [state, setState] = useState<PlaybackControlState>(DEFAULT_STATE);
  const shiftOptions = shiftConfigs
    ? shiftConfigs.map((shiftConfig) => {
        if (shiftConfig && shiftConfig.Id && shiftConfig.title) {
          return {
            label: shiftConfig.title as string,
            value: shiftConfig.Id as string,
          } as FormOption;
        }
      })
    : ([] as FormOption[]);
  useEffect(() => {
    const shift = shiftConfigs?.find((shiftConfig) => {
      return shiftConfig.number === state.shiftNumber;
    });

    if (shift) {
      handleShiftChange(shift.number);
      setState({
        ...state,
        shiftOption: {
          label: shift.title as string,
          value: shift.Id,
        },
        loading: false,
      });
    }
  }, []);

  const _handleShiftChange = (event: any) => {
    const shift = shiftConfigs?.find((shiftConfig) => {
      return shiftConfig.Id == event.target.value;
    });
    if (shift) {
      handleShiftChange(shift.number);
      setState({
        ...state,
        shiftOption: {
          label: shift.title as string,
          value: shift.Id,
        },
        shiftNumber: shift.number,
        loading: false,
      });
    }
  };

  const _handleDateChange = (event: any) => {
    console.log(
      "🚀 ~ file: PlaybackControl.tsx ~ line 63 ~ handleDateChange ~ event",
      event.target.value
    );
    handleDateChange(event.target.value);
    setState({ ...state, shiftDate: event.target.value });
  };

  if (state.loading) {
    return <LinearProgress />;
  } else if (state.shiftOption) {
    const inputs: ConfigInput[] = [
      {
        title: "Select Date",
        onChange: _handleDateChange,
        xs: 12,
        sm: 6,
        id: "selectShift",
        type: "date",
      },
      {
        title: "Select Shift",
        type: "radio",
        onChange: _handleShiftChange,
        xs: 12,
        sm: 6,
        id: "trackingType",
        placeholder: "select tracking type",
        options: shiftOptions as FormOption[],
        value: state.shiftOption.value,
      },
    ];
    return <ConfigForm inputs={inputs} />;
  } else {
    return <div> error shift configs not set</div>;
  }
}
